/**
* This file was @generated using pocketbase-typegen
*/

import type PocketBase from 'pocketbase'
import type { RecordService } from 'pocketbase'

export enum Collections {
	Points = "points",
	Roles = "roles",
	Trips = "trips",
	TripsMetaData = "tripsMetaData",
	Users = "users",
	Vehicles = "vehicles",
}

// Alias types for improved usability
export type IsoDateString = string
export type RecordIdString = string
export type HTMLString = string

// System fields
export type BaseSystemFields<T = never> = {
	id: RecordIdString
	created: IsoDateString
	updated: IsoDateString
	collectionId: string
	collectionName: Collections
	expand?: T
}

export type AuthSystemFields<T = never> = {
	email: string
	emailVisibility: boolean
	username: string
	verified: boolean
} & BaseSystemFields<T>

// Record types for each collection

export enum PointsProjectionOptions {
	"webMercator" = "webMercator",
}
export type PointsRecord = {
	adress?: string
	index?: number
	lat?: number
	lon?: number
	projection?: PointsProjectionOptions
}

export type RolesRecord = {
	role?: string
}

export enum TripsStatusOptions {
	"available" = "available",
	"live" = "live",
	"ended" = "ended",
	"paused" = "paused",
}
export type TripsRecord = {
	driver?: RecordIdString
	livelat?: number
	livelon?: number
	metaData?: RecordIdString
	passengers?: RecordIdString[]
	status?: TripsStatusOptions
	test8?: string
	vehicle?: RecordIdString
}

export enum TripsMetaDataStatusOptions {
	"upcoming" = "upcoming",
	"live" = "live",
	"ended" = "ended",
}

export enum TripsMetaDataDaysOptions {
	"Monday" = "Monday",
	"Tuesday" = "Tuesday",
	"Wednesday" = "Wednesday",
	"Thursday" = "Thursday",
	"Friday" = "Friday",
	"Saturday" = "Saturday",
	"Sunday" = "Sunday",
}
export type TripsMetaDataRecord = {
	createdby?: RecordIdString
	days?: TripsMetaDataDaysOptions[]
	endDate?: IsoDateString
	maxSubscribers?: number
	points?: RecordIdString[]
	startDate?: IsoDateString
	status?: TripsMetaDataStatusOptions
	title?: string
	updatedby?: RecordIdString
}

export type UsersRecord = {
	avatar?: string
	name?: string
	roles?: RecordIdString[]
}

export type VehiclesRecord = {
	color?: string
	numberOfSeats?: number
	plateCode?: string
	type?: string
}

// Response types include system fields and match responses from the PocketBase API
export type PointsResponse<Texpand = unknown> = Required<PointsRecord> & BaseSystemFields<Texpand>
export type RolesResponse<Texpand = unknown> = Required<RolesRecord> & BaseSystemFields<Texpand>
export type TripsResponse<Texpand = unknown> = Required<TripsRecord> & BaseSystemFields<Texpand>
export type TripsMetaDataResponse<Texpand = unknown> = Required<TripsMetaDataRecord> & BaseSystemFields<Texpand>
export type UsersResponse<Texpand = unknown> = Required<UsersRecord> & AuthSystemFields<Texpand>
export type VehiclesResponse<Texpand = unknown> = Required<VehiclesRecord> & BaseSystemFields<Texpand>

// Types containing all Records and Responses, useful for creating typing helper functions

export type CollectionRecords = {
	points: PointsRecord
	roles: RolesRecord
	trips: TripsRecord
	tripsMetaData: TripsMetaDataRecord
	users: UsersRecord
	vehicles: VehiclesRecord
}

export type CollectionResponses = {
	points: PointsResponse
	roles: RolesResponse
	trips: TripsResponse
	tripsMetaData: TripsMetaDataResponse
	users: UsersResponse
	vehicles: VehiclesResponse
}

// Type for usage with type asserted PocketBase instance
// https://github.com/pocketbase/js-sdk#specify-typescript-definitions

export type TypedPocketBase = PocketBase & {
	collection(idOrName: 'points'): RecordService<PointsResponse>
	collection(idOrName: 'roles'): RecordService<RolesResponse>
	collection(idOrName: 'trips'): RecordService<TripsResponse>
	collection(idOrName: 'tripsMetaData'): RecordService<TripsMetaDataResponse>
	collection(idOrName: 'users'): RecordService<UsersResponse>
	collection(idOrName: 'vehicles'): RecordService<VehiclesResponse>
}
